export const onUpdate = (table, id, reactions) => ({
  type: 'UPDATE',
  table,
  id,
  reactions
})
